module.exports = __webpack_public_path__ + "static/media/gas_03.75a744d2.svg";